import { createSlice } from '@reduxjs/toolkit';
import { initialState } from "./initialState";
import { getCloudStorage } from 'api/thunk/cloudStorage/getActions/getCloudStorage';
import { getCloudStorageById } from 'api/thunk/cloudStorage/getActions/getCloudStorageById';

const cloudStorageSlice = createSlice({
  name: "applications",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(getCloudStorage.pending, (state) => {
        state.getCloudStorage.response.loading = true;
        state.getCloudStorage.response.error = null;
      })
      .addCase(getCloudStorage.fulfilled, (state, action) => {
        state.getCloudStorage.response.loading = false;
        state.getCloudStorage.response.data = action.payload;
      })
      .addCase(getCloudStorage.rejected, (state, action) => {
        state.getCloudStorage.response.loading = false;
        state.getCloudStorage.response.error =
          action.error.message || "Неизвестная ошибка";
      })
      .addCase(getCloudStorageById.pending, (state) => {
        state.getCloudStorageById.response.loading = true;
        state.getCloudStorageById.response.error = null;
      })
      .addCase(getCloudStorageById.fulfilled, (state, action) => {
        state.getCloudStorageById.response.loading = false;
        state.getCloudStorageById.response.data = action.payload;
      })
      .addCase(getCloudStorageById.rejected, (state, action) => {
        state.getCloudStorageById.response.loading = false;
        state.getCloudStorageById.response.error =
          action.error.message || "Неизвестная ошибка";
      })
});

export default cloudStorageSlice.reducer;